import sanitizeHtml from 'sanitize-html';
import DOMPurify from 'isomorphic-dompurify';
import xss from 'xss';

export const handleRichText = (html: string) => {
  const handledHtml = sanitizeHtml(html, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat([
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'p',
      'em',
      'u',
      'sup',
      'ul',
      'ol',
      'li',
      'img',
      'table',
      'thead',
      'tr',
      'th',
      'tbody',
      'td',
      'iframe',
      'span',
      'strong',
      'colgroup',
      'col',
      'video',
      'del',
    ]),
    allowedAttributes: {
      a: ['href', 'name', 'target', 'class'],
      img: ['src', 'class', 'name', 'alt'],
      iframe: [
        'height',
        'width',
        'src',
        'srcdoc',
        'frameborder',
        'allow',
        'title',
        'sandbox',
        'origin',
        'enablejsapi',
        'autoplay',
      ],
      colgroup: ['data-width'],
      col: ['style'],
      td: ['rowspan', 'colspan', 'style'],
      video: ['src', 'poster', 'width', 'height'],
      table: ['style'],
      thead: ['style'],
      tr: ['style'],
      th: ['style'],
      tbody: ['style'],
      div: ['style', 'class'],
      span: ['class', 'id'],
      h2: ['id'],
      li: ['style'],
      p: ['style'],
    },
    allowedSchemes: ['http', 'https'],
    allowedSchemesAppliedToAttributes: ['href', 'src'],
  });
  const options = {
    whiteList: {
      a: ['href', 'name', 'target', 'class'],
      img: ['src', 'class', 'name', 'alt'],
      iframe: [
        'height',
        'width',
        'src',
        'srcdoc',
        'frameborder',
        'allow',
        'title',
        'sandbox',
        'origin',
        'enablejsapi',
        'autoplay',
      ],
      colgroup: ['data-width'],
      col: ['style'],
      td: ['rowspan', 'colspan', 'style'],
      video: ['src', 'poster', 'width', 'height'],
      table: ['style'],
      thead: ['style'],
      tr: ['style'],
      th: ['style'],
      tbody: ['style'],
      div: ['style', 'class'],
      span: ['class', 'id'],
      h2: ['id'],
      li: ['style'],
      p: ['style'],
      h3: [],
      h4: [],
      h5: [],
      h6: [],
      sup: [],
      strong: [],
      ul: [],
      ol: [],
      br: [],
      em: [],
      del: [],
      figure: [],
      u: [],
      wbr: [],
    },
  };
  let sanHtml = DOMPurify.sanitize(handledHtml, {
    ADD_TAGS: ['iframe', 'a'],
    ADD_ATTR: [
      'height',
      'width',
      'src',
      'srcdoc',
      'frameborder',
      'allow',
      'title',
      'sandbox',
      'origin',
      'enablejsapi',
      'autoplay',
      'href',
      'name',
      'target',
      'class',
    ],
  });

  return xss(sanHtml, options);
};
